import { debounce, put, call, takeLatest } from 'redux-saga/effects'

// Redux
import * as types from 'Redux/Types/ReportTypes'
import * as actions from 'Redux/Actions/ReportActions'
import * as reconciliationActions from 'Redux/Actions/ReconciliationActions'

// Services
import * as api from 'Service/Api'

function* createReportWorker({ payload }) {
  try {
    const response = yield call(api.generateReport, payload)
    const reportsResponse = yield call(api.getReportTemplates, {
      limit: 20,
      offset: 0,
      filters: {},
    })
    yield put(actions.fetchReportsSucceeded(reportsResponse))
    yield put(actions.createReportSucceeded(response.data))
  } catch (error) {
    yield put(actions.createReportFailed(error))
  }
}

function* deleteReportWorker({ payload }) {
  try {
    const response = yield call(api.deleteReport, payload)
    const reportsResponse = yield call(api.getReportTemplates, {
      limit: 20,
      offset: 0,
      filters: {},
    })
    yield put(actions.fetchReportsSucceeded(reportsResponse))
    yield put(actions.deleteReportSucceeded(response))
  } catch (error) {
    yield put(actions.deleteReportFailed(error))
  }
}

function* fetchAuditLogsWorker({ payload }) {
  try {
    const response = yield call(api.fetchAuditLogs, payload)
    yield put(actions.fetchAuditLogsSucceeded(response))
  } catch (errors) {
    yield put(actions.fetchAuditLogsFailed(errors))
  }
}

function* fetchReportExpensesWorker({ payload }) {
  try {
    const response = yield call(api.getLedgerRecords, payload)
    yield put(actions.fetchReportExpensesSucceeded(response))
  } catch (errors) {
    yield put(actions.fetchReportExpensesFailed(errors))
  }
}

function* fetchReportsWorker({ payload }) {
  try {
    const response = yield call(api.getReportTemplates, payload)
    yield put(actions.fetchReportsSucceeded(response))
  } catch (error) {
    yield put(actions.fetchReportsFailed(error))
  }
}

function* updateReportWorker({ payload }) {
  try {
    const response = yield call(api.updateReport, payload.id, payload)
    const reportsResponse = yield call(api.getReportTemplates, {
      limit: 20,
      offset: 0,
      filters: {},
    })
    yield put(actions.fetchReportsSucceeded(reportsResponse))
    yield put(actions.updateReportSucceeded(response))
  } catch (error) {
    yield put(actions.updateReportFailed(error))
  }
}

function* createExportReportWorker({ payload }) {
  try {
    const response = yield call(api.generateReport, payload)
    yield put(actions.createExportReportSucceeded(response.data))
  } catch (error) {
    yield put(actions.createExportReportFailed(error))
  }
}

function* createTransactionReportWorker({ payload }) {
  try {
    const response = yield call(api.generateReport, payload)
    yield put(actions.createTransactionReportSucceeded(response.data))
    if (payload?.markAsArchived) {
      const transactionsResponse = yield call(api.getTransactionData, {
        limit: 20,
        offset: 0,
        filters: {},
      })
      yield put(reconciliationActions.getTransactionDataSucceeded(transactionsResponse))
    }
  } catch (error) {
    yield put(actions.createTransactionReportFailed(error))
  }
}

export default function* reportsSaga() {
  yield takeLatest(types.CREATE_REPORT, createReportWorker)
  yield takeLatest(types.CREATE_EXPORT_REPORT, createExportReportWorker)
  yield takeLatest(types.CREATE_TRANSACTION_REPORT, createTransactionReportWorker)
  yield takeLatest(types.DELETE_REPORT, deleteReportWorker)
  yield debounce(150, types.FETCH_AUDIT_LOGS, fetchAuditLogsWorker)
  yield debounce(150, types.FETCH_REPORT_EXPENSES, fetchReportExpensesWorker)
  yield takeLatest(types.FETCH_REPORTS, fetchReportsWorker)
  yield takeLatest(types.UPDATE_REPORT, updateReportWorker)
}
